import React, {useState} from 'react';

import FormWizard from '../form-wizard/FormWizard';
import NextArrowButton from "../../atoms/next-arrow-button/nextArrowButton";
import PreviousArrowButton from "../../atoms/previous-arrow-button/previousArrowButton";
import contentfulRenderOptions from '../../../utils/contentfulRenderOption';

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

import './SpecialRoutes.scss';

const SpecialRoutes = ({tituloGeneral, referenciaPlantillaContenido, selectorDeColor}: ReferenciaContenido) =>{
    const [activeStep, setActiveStep] = useState<number>(0);

    const isActiveBack : () => boolean = () => {
        return activeStep !== 0;
    }
    const goToBack : () => void = () => {
        setActiveStep(activeStep - 1);
    }
    const isActiveNext : () => boolean = () => {
        return activeStep !== referenciaPlantillaContenido.length - 1;
    }
    const goToNext : () => void = () => {
        setActiveStep(activeStep + 1);
    }

    const wizardArray :{ idx: number; description: string; active: boolean }[] = referenciaPlantillaContenido.map((_, index)=>{return{idx:index, active:index<activeStep+1, description:""}});
    const blockName : string = "m-special-routes";

    console.log(referenciaPlantillaContenido);

    return (
        <section className={blockName}>
            <h3 className={`${blockName}__title`}>{tituloGeneral}</h3>
            <div className={`${blockName}__card`} style={{backgroundColor : selectorDeColor.value}}>
                { window.innerWidth <= 768 &&
                    <div className={`${blockName}__card-header-mobile`}>
                        <FormWizard activeIndex={activeStep} setActiveIndex={setActiveStep} wizards={wizardArray}/>
                        <div className={`${blockName}__card-mobile-buttons`}>
                            <PreviousArrowButton canGoPrev={isActiveBack()} onClick={goToBack}/>
                            <h4>{referenciaPlantillaContenido[activeStep].tituloBanner}</h4>
                            <NextArrowButton canGoNext={isActiveNext()} onClick={goToNext}/>
                        </div>
                    </div>
                }
                { window.innerWidth > 768 &&
                    <div className={`${blockName}__card-nav-desktop`}>
                        {
                            referenciaPlantillaContenido.map((item, index)=>{
                                return(
                                    <button className={`${blockName}__card-nav-button ${index===activeStep ? "m-special-routes__card-nav-button--active":""}`} onClick={()=>{setActiveStep(index)}}>
                                        <figure>
                                            <img src={item.imagenPerfil.file.url}/>
                                        </figure>
                                        <span>{item.tituloBanner}</span>
                                    </button>
                                );
                            })
                        }
                    </div>
                }
                <div className={`${blockName}__card-content`}>
                    <img className={`${blockName}__card-img`} src={referenciaPlantillaContenido[activeStep].imagenPrincipal[0].file.url}/>
                    {contentfulRenderOptions(referenciaPlantillaContenido[activeStep].descripcion.json)}
                </div>
            </div>
        </section>
    );
}

export default SpecialRoutes;